import { inject, provide, type InjectionKey } from 'vue'
import { toValue, type MaybeRefOrGetter } from 'vue'

import { useDistributorDocuments } from '@/composables/useDistributorDocuments'
import type { ApplicationDetailsApplicantResponse, DistributorDocument } from '@/services/application'
import { getFullName } from '@/utils/applicationDisplay'

export type ApplicationDocumentsContext = ReturnType<typeof useDistributorDocuments>

const APPLICATION_DOCUMENTS_CONTEXT_KEY = Symbol() as InjectionKey<ApplicationDocumentsContext>

export const provideApplicationDocumentsContext = (applicationId: MaybeRefOrGetter<string>) => {
  const context = useDistributorDocuments(() => ({ applicationId: toValue(applicationId) }))
  provide(APPLICATION_DOCUMENTS_CONTEXT_KEY, context)
  return context
}

export const useApplicationDocumentsContext = () => {
  const context = inject(APPLICATION_DOCUMENTS_CONTEXT_KEY)

  if (!context) {
    throw new Error('useApplicationDocumentsContext must be used within ApplicationLayout.')
  }

  return context
}

export const getDocumentsByType = (documents: readonly DistributorDocument[], type: string) => {
  return documents.filter((doc) => doc.type === type)
}

export const getDocumentRelation = (
  applicants: ApplicationDetailsApplicantResponse[] | undefined,
  relations?: DistributorDocument['relations'],
): string => {
  if (relations?.userId) {
    const applicant = applicants?.find((a) => a.userId === relations.userId)
    return applicant ? getFullName(applicant) : '-'
  }
  if (relations?.applicationId) return 'Ansökan'
  if (relations?.debtId) return 'Bolånet'
  return '-'
}
